import { render, staticRenderFns } from "./ReviewHeader.vue?vue&type=template&id=7179324e"
import script from "./ReviewHeader.vue?vue&type=script&lang=js"
export * from "./ReviewHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports